import { gql } from "@apollo/client";

export const Client = gql`
query DA_Adduser_dropdown1 {
    aatmsv4_clients(where: {active: {_eq: true}}, order_by: {clientname:
   asc}) {
    clientname
    clientsid
    department
    }
}
`
export const GetUsers = gql`
query da_edituser_list(
    $clientid: uuid,
    $active: Boolean
    ) {
    aatmsv4_users(order_by: {client: {clientname: asc}, fleet: {aircraft: asc}, email: asc}, where: {active: {_eq: $active}, clientid: {_eq: $clientid}}) {
      client {
        clientname
      }
      fleet {
        aircraft
      }
      email
      active
      _crew
      _ground
      _simulator
      _aircraft
      _manager
      _optimiser
      _dataadmin
      userid
    }
  }
  
`
export const ActiveUsers = gql`
mutation da_editUser_active_false(
$userid: String
$active: Boolean
) {
    update_aatmsv4_users(where: {userid: {_eq:$userid}}, _set: {active: $active}) {
    returning {
    userid
    active
    }
    }
   }
`
export const ActiveUserCrew = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_crews(where: {crewid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            crewid
            active
            }
            }
    }
`
export const ActiveUserGround = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_groundinst(where: {userid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            userid
            active
            }
            }
    }
`
export const ActiveUserSimulator = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_simulatorinst(where: {usersid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            usersid
            active
            }
            }
    }
`
export const ActiveUserAircraft = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_aircraftinst(where: {usersid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            managersid
            active
            }
            }
    }
`
export const ActiveUserManager = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_managers(where: {managersid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            managersid
            active
            }
            }
    }
`
export const ActiveUserDataAdmin = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_dataadmin(where: {userid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            userid
            active
            }
            }
    }
`
export const ActiveUserOptimiser = gql`
mutation da_editUser_active_false(
    $userid: String
    $active: Boolean
    ){
        update_aatmsv4_optimiser(where: {usersid: {_eq:$userid}}, _set: {active: $active}) {
            returning {
            usersid
            active
            }
            }
    }
`

export const aircraft_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $aircraft: Boolean
) {
    update_aatmsv4_aircraftinst(where: {usersid: {_eq: $usersid}}, _set: {active: $aircraft}) {
        returning {
        usersid
        }
        }
}
`
export const crew_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $crew: Boolean
) {
    update_aatmsv4_crews(where: {crewid: {_eq: $usersid}}, _set: {active: $crew}) {
        returning {
        crewid
        }
        }
}
`
export const dataAdmin_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $dataAdmin: Boolean
) {
    update_aatmsv4_dataadmin(where: {userid: {_eq: $usersid}}, _set: {active: $dataAdmin}) {
        returning {
        userid
        }
        }
}
`
export const ground_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $Ground: Boolean
) {
    update_aatmsv4_groundinst(where: {userid: {_eq: $usersid}}, _set: {active: $Ground}) {
        returning {
        userid
        }
        }
}
`
export const manager_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $manager: Boolean
) {
    update_aatmsv4_managers(where: {managersid: {_eq: $usersid}}, _set: {active: $manager}) {
        returning {
        managersid
        }
        }
}
`
export const optimiser_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $optimiser: Boolean
) {
    update_aatmsv4_optimiser(_set: {active: $optimiser}, where: {usersid: {_eq: $usersid}}) {
        returning {
        usersid
        }
        }
}
`
export const simulator_active = gql`
mutation DA_EDITUSER_OPTION2(
    $usersid: String
    $Simulator: Boolean
) {
    update_aatmsv4_simulatorinst(where: {usersid: {_eq: $usersid}}, _set: {active: $Simulator}) {
        returning {
        usersid
        }
        }
}
`
export const user_active = gql`
mutation MyMutation(
    $usersid: String
    $Simulator: Boolean
    $optimiser: Boolean
    $manager: Boolean
    $Ground: Boolean
    $dataAdmin: Boolean
    $crew: Boolean
    $aircraft: Boolean
    $active: Boolean
) {
    update_aatmsv4_users(where: {userid: {_eq: $usersid}}, _set: {_aircraft: $aircraft,
         _crew: $crew, _dataadmin: $dataAdmin, _ground: $Ground, _manager: $manager,
          _optimiser: $optimiser, _simulator: $Simulator, active: $active}) {
      returning {
        active
      }
    }
  }
`
export const register_active = gql`
mutation MyMutation(
    $usersid: String
    $Simulator: Boolean
    $optimiser: Boolean
    $manager: Boolean
    $Ground: Boolean
    $dataAdmin: Boolean
    $crew: Boolean
    $aircraft: Boolean
) {
    update_aatmsv4_register(where: {userid: {_eq: $usersid}}, _set: {aircraft: $aircraft, crew: $crew, dataadmin: $dataAdmin, ground: $Ground, optimiser: $optimiser, simulator: $Simulator, managers: $manager}) {
      returning {
        userid
      }
    }
  }
  
`
export const GetUsersDetails = gql`
query da_edituserDetails_list(
    $clientsid: uuid,
    $managersid: String,
    $fleetsid:uuid
    ) {
    aatmsv4_clients(where: {clientsid: {_eq: $clientsid}}) {
      clientname
      department
      managers(where: {managersid: {_eq: $managersid}}){
          managername
      }
      fleets(where: {fleetsid: {_eq: $fleetsid}}){
        aircraft
      }
    }
  }
  
`